<template>
  <project-layout :projectName="this.$options.name">
    <p>Wikiprice was my major project during my last semester at Sydney Uni. The idea was to make an interactive currency comparison tool powered by people around the world, instead of some specific organisation.</p>
    <img :src="imagePath + 'works-wikiprice-00.svg'" :alt="this.$options.name" class="mw280" />
    <img :src="imagePath + 'works-wikiprice-01.png'" :alt="this.$options.name" class="border shadow round"/>
    <img :src="imagePath + 'works-wikiprice-02.png'" :alt="this.$options.name" class="border shadow round"/>
    <img :src="imagePath + 'works-wikiprice-03.png'" :alt="this.$options.name" class="border shadow round"/>
    <p>This price comparison index is based on the theory of purchasing-power parity (PPP). Purchasing power parity is a component of some economic theories and is a technique used to determine the relative value of different currencies.</p>
    <div class="cols col-2">
      <img :src="imagePath + 'works-wikiprice-04.png'" :alt="this.$options.name" class="border round" />
      <img :src="imagePath + 'works-wikiprice-05.png'" :alt="this.$options.name" class="border round" />
    </div>
    <img :src="imagePath + 'works-wikiprice-06.png'" :alt="this.$options.name" class="mw800" />
    <img :src="imagePath + 'works-wikiprice-07.jpg'" :alt="this.$options.name" class="mw730 border" />
    <em class="desc">Sketches</em>
  </project-layout>  
</template>

<script>
  import ProjectLayout from '@/layouts/ProjectLayout.vue'
  import DataPath from '@/components/DataPath.vue'

  export default {
    name: 'wikiprice',
    components: {
      'project-layout': ProjectLayout
    },
    data () {
      return {
        imagePath: '',
        videoPath: ''
      }
    },
    created () {
      this.imagePath = DataPath.data().imagePath + this.$options.name + '/'
      this.videoPath = DataPath.data().videoPath + this.$options.name + '/'
    }
  }
</script>

<style lang="sass" scoped>
</style>


// WEBPACK FOOTER //
// src/contents/WikiPrice.vue